<template>
  <div class="user-page full-height">
    <table-con>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">商品渠道:</div>
              <el-select
                v-model="queryInfo.platformType"
                placeholder="请选择商品渠道"
                size="small"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <!-- <el-input
                v-model="query.name"
                size="small"
                placeholder="请输入商品渠道"
              ></el-input> -->
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">商品名称:</div>
              <el-input
                v-model="queryInfo.goodsName"
                size="small"
                placeholder="请输入商品名称"
              ></el-input>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">录入用户:</div>
              <el-input
                v-model="queryInfo.createUserName"
                size="small"
                placeholder="请输入录入用户"
              ></el-input>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">录入日期:</div>
              <el-date-picker
                style="width: 100%"
                v-model="queryInfo.dateRangeValue"
                type="daterange"
                size="small"
                format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-col>
          </el-row>
          <!-- <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">标签:</div>
              <el-input
                v-model="query.name"
                size="small"
                placeholder="请输入标签"
              ></el-input>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">商品分类:</div>
              <el-input
                v-model="query.name"
                size="small"
                placeholder="请输入商品分类"
              ></el-input>
            </el-col>
          </el-row> -->
        </el-collapse>
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">商品编码:</div>
            <el-input
                v-model="queryInfo.goodsCode"
                size="small"
                placeholder="请输入商品编码"
            ></el-input>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="search-btn-container search-btn-container-status">
              &nbsp;
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="search-btn-container search-btn-container-status">
              &nbsp;
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-gray" @click="queryInfoClear"
                >重置</el-button
              >
              <el-button
                class="search-btn btn-blue"
                @click="handleCurrentChange(1)"
                >搜索</el-button
              >
              <!-- <el-button class="search-btn btn-blue">增加商品</el-button>
              <el-button class="search-btn btn-blue">批量导入</el-button> -->
              <el-button
                class="search-btn btn-blue"
                v-if="!isActive"
                type="primary"
                icon="el-icon-arrow-down"
                alt=""
                @click="isActive = !isActive"
                >展开</el-button
              >
              <el-button
                class="search-btn btn-green"
                v-if="isActive"
                icon="el-icon-arrow-up"
                alt=""
                @click="isActive = !isActive"
                >收起</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
          :header-cell-style="tableStyle.headerStyle"
          :cell-style="tableStyle.cellStyle"
          :data="tableList"
          border
          height="550"
        >
          <el-table-column type="index" label="序号" align="center" />
          <el-table-column prop="" label="操作" align="center" width="150px">
            <template #default="{ row }">
              <el-button class="list-btn btn-blue" @click="onEdit(row)"
                >编辑</el-button
              >
              <!-- <el-button class="search-btn btn-red" @click="onRemove(row)"
                >删除</el-button
              > -->
            </template>
          </el-table-column>
          <el-table-column prop="platformType" label="商品渠道" align="center">
            <template #default="{ row }">
              <span>{{
                returnStatus(row.platformType, platformType_status)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="商品图片" align="center">
            <template #default="{ row }">
              <img
                :src="row.pictureUrl"
                style="cursor: pointer"
                width="50px"
                height="50px"
                @click="chackImg(row)"
              />
            </template>
          </el-table-column>
          <el-table-column prop="address" label="商品信息" width="200px">
            <template #default="{ row }">
              <div>商品名称：{{ row.goodsName }}</div>
              <div>商品编码：{{ row.goodsCode }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="商品参数" width="200px">
            <template #default="{ row }">
              <div>规格：{{ row.goodsSize }}</div>
              <div>平均价格：{{ row.priceAvg }}</div>
              <!-- {{ row.goodsUrl }} -->
              <div style="cursor: pointer">
                商品链接：<a :href="row.goodsUrl">商品链接</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="录入日期"
            width="90"
            align="center"
          >
            <template #default="{ row }">
              {{ row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createUserName"
            label="录入用户"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="orderCount" label="采购次数" align="center">
          </el-table-column>
          <el-table-column
            prop="checkCoefficientAvg"
            label="平均系数"
            align="center"
          >
          <template #default="{ row }">
              {{ +(row.checkCoefficientAvg || 0).toFixed(2) }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="address" label="标签" align="center">
            <template #default="{ row }">
              <el-tag>标签</el-tag>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="address" label="分类" align="center">
          </el-table-column> -->
          <el-table-column prop="remark" label="国内运费">
            <template #default="{ row }">
              <el-input
                  placeholder="请输入国内运费"
                  @blur="getEvalue(row)"
                  v-model="row.inlandFreight"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注">
            <template #default="{ row }">
              <el-input
                type="textarea"
                placeholder="请输入备注"
                @blur="getEvalue(row)"
                v-model="row.remark"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 图片预览 -->
        <el-dialog
          :visible.sync="dialogVisible"
          v-if="dialogVisible"
          width="30%"
        >
          <img :src="dialogPic" width="100%" height="100%" />
        </el-dialog>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[5, 10, 20, 50, 100, 200]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>

      </div>
    </table-con>
  </div>
</template>

<script>
import { returnStatus, platformType_status } from "@/class/status";
export default {
  name: "goods",
  // name: "goods/goodsList",
  data() {
    return {
      returnStatus: returnStatus,
      platformType_status: platformType_status,
      tableList: [],
      queryInfo: {
        pageNum:1,
        pageSize:10,
        platformType:'',
        goodsName:'',
        createUserName:'',
        dateRangeValue: [],
        goodsCode:''
      },
      total:0,
      visiable: false,
      title: undefined,
      dialogVisible: false,
      dialogPic: undefined,
      isActive:true,
      options: [
        {
          value: "0",
          label: "淘宝",
        },
        {
          value: "1",
          label: "1688",
        },
        {
          value: "2",
          label: "京东",
        },
        {
          value: "3",
          label: "拼多多",
        },
        {
          value: "4",
          label: "天猫",
        },
      ],
    };
  },
  watch: {
    //监听时间选择器绑定值变化
    dateRangeValue() {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.dateRangeValue) {
        this.dateRangeValue = [];
        this.query.createTimeStart = "";
        this.query.createTimeEnd = "";
      } else {
        if (this.dateRangeValue.length > 0) {
          this.query.createTimeStart = this.dateRangeValue[0] / 1000;
          this.query.createTimeEnd = this.dateRangeValue[1] / 1000 + 86400;
        }
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    // 查看图片
    chackImg(row) {
      this.dialogVisible = true;
      this.dialogPic = row.pictureUrl;
    },
    // 编辑adn备注
    getEvalue(row) {
      let data = {
        id: row?.id,
        remark: row?.remark,
        inlandFreight: row?.inlandFreight,
      };
      this.$http.post("/purchase/updateGoods", data).then((res) => {
        const { data: resData } = res;
        if (resData.code == 200) {
          this.$message({
            type: "success",
            message: resData.data,
          });
          this.queryInfo.searchList();
        }
      });
    },
    // 编辑
    onEdit(row) {
      this.$router.push({ path: "/goodsDetails", query: { id: row.id } });
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getList();
    },
    // 列表
    getList() {
      this.$http
          .get("/purchase/goodsList", {
            params: this.queryInfo,
          })
          .then((res) => {
            const { data: resData } = res;
            this.tableList = resData.data.list;
            this.total = resData.data.total;
          });
    },
    // 重置
    queryInfoClear() {
      this.queryInfo.pageNum = 1;
      this.queryInfo.platformType = '';
      this.queryInfo.goodsName = '';
      this.queryInfo.createUserName = '';
      this.queryInfo.dateRangeValue = [];
      this.queryInfo.goodsCode = '';
    },
  },
};
</script>

<style lang="scss" scoped></style>
